import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import { useEffect } from "react";

//Components
import { Modal, ModalBody, ModalFooter, Button } from "@gpstrackit/react-controls";
import { NotificationManager } from 'Components/Notifications';

//Actions
import {
    clearRedux,
    unitTypeEventDeleteRequest,
    searchEntityRequest,
} from 'Redux/actions';

const DeleteUnitTypeEvent = (props) => {
    const { tableRef, loadData } = props;
    const { messages } = useIntl();
    const dispatch = useDispatch();

    const { manufacturers, unitTypes, events } = useSelector(state => state.generalRedux);

    const {
        openModal,
        loading,
        unitTypeEvents,
        resultDeleteUnitTypeEvent,
    } = useSelector(state => state.deleteUnitTypeEventRedux);

    const handleDelete = () => {
        dispatch(unitTypeEventDeleteRequest(unitTypeEvents?.map(x => x.id)))
    }

    const closeModalDeleteUnitTypeEvent = () => {
        dispatch(clearRedux("UNIT_TYPE_EVENT_DELETE"))
    }

    useEffect(() => {
        if (resultDeleteUnitTypeEvent) {
            NotificationManager.success(
                messages['unit_type_event_delete_success_message'],
                messages['unit_type_event_delete_title'],
                3000
            );
            tableRef && tableRef?.current?.getData();
            closeModalDeleteUnitTypeEvent()
            dispatch(clearRedux("UNIT_TYPE_EVENT_DELETE", { resultDeleteUnitTypeEvent: null }))
            loadData && loadData();
        }
    }, [resultDeleteUnitTypeEvent])

    useEffect(() => {
        (!unitTypes || unitTypes?.length === 0) && dispatch(searchEntityRequest({ key: "unitTypes" }));
    }, [])

    return (
        <Modal
            open={openModal}
            title={`${messages['unit_type_event_delete_title']}`}
            handleClose={() => closeModalDeleteUnitTypeEvent()}
            position="right"
            loading={loading}
            size="small"
        >
            <ModalBody>
                <div style={{ padding: '0 10px', height: 600 }}>
                    {messages['unit_type_event_delete_message']}
                    <ul style={{ marginTop: 10 }}>
                        {
                            unitTypeEvents.map((item, key) => {
                                let unitType = unitTypes.find(x => x.id === item.unitTypeId)
                                return (
                                    <li key={key}>{`${unitType?.manufacturer.name} - ${unitType?.name} - ${item?.event?.name}`}</li>
                                )
                            })
                        }
                    </ul>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn btn-cancel"
                    onClick={() => closeModalDeleteUnitTypeEvent()}
                >
                    {messages['common_cancel']}
                </Button>
                <Button
                    className="btn-dark-blue"
                    onClick={handleDelete}
                >
                    {messages['delete']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default DeleteUnitTypeEvent;


